import React, { useContext } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import DyteClient from '@dytesdk/web-core';
import { useDyteSelector } from '@dytesdk/react-native-core';
import DyteText from './DyteText';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  iconPack = defaultIconPack,
  t,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  t?: DyteI18n;
}) {
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  iconPack = iconPack ?? defaultIconPack;
  const joinedParticipants = useDyteSelector((m) => m.participants.joined);
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const styles = StyleSheet.create({
    wrapper: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    container: {
      flexDirection: 'row',
      borderRadius: 4,
      alignItems: 'center',
      justifyContent: 'center',
    },
    peopleIcon: {
      padding: 4,
      paddingLeft: 8,
    },
    text: {
      color: colors.text,
      // paddingRight: 8,
    },
  });
  if (
    meeting.meta.viewType === 'LIVESTREAM' &&
    meeting.stage.status !== 'ON_STAGE'
  )
    return null;
  return (
    <TouchableHighlight
      underlayColor={colors.background[800]}
      style={styles.wrapper}
      onPress={() => {
        if (meeting.livestream) {
          if (
            meeting.stage.status !== 'OFF_STAGE' &&
            meeting.self.permissions.acceptStageRequests
          )
            setStates({
              ...storeStates,
              activeSidebar: true,
              activeMoreMenu: false,
              sidebar: 'participants',
            });
        } else {
          setStates({
            ...storeStates,
            activeSidebar: true,
            activeMoreMenu: false,
            sidebar: 'participants',
          });
        }
      }}
    >
      <View style={styles.container}>
        <DyteText style={styles.text}>
          {joinedParticipants.toArray().length + 1}{' '}
          {joinedParticipants.toArray().length > 0
            ? t('participants')
            : 'Participant'}
        </DyteText>
      </View>
    </TouchableHighlight>
  );
}
